import type { TFunction } from "i18next";

import { LOGIC, type Logic } from "./constants";

export const getRuleLabel = (t: TFunction, ruleIndex: number): string =>
  `${t("admin.segments.builder.rule.label")} ${ruleIndex + 1}`;

export const getLogicLabel = (t: TFunction, logic: Logic): string =>
  t(logic === LOGIC.AND ? "common.and" : "common.or").toUpperCase();
